import React from 'react';
import { Hero } from '../components/sections/Hero';
import { WhatIsDigitalKey } from '../components/sections/WhatIsDigitalKey';
import { FeatureGrid } from '../components/sections/FeatureGrid';
import { ControlModes } from '../components/sections/ControlModes';
import { Security } from '../components/sections/Security';
import { Stats } from '../components/sections/Stats';
import { UseCases } from '../components/sections/UseCases';
import { Installation } from '../components/sections/Installation';
import { VehicleModels } from '../components/sections/VehicleModels';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
interface HomeProps {
  onNavigate: (page: string) => void;
}
export function Home({
  onNavigate
}: HomeProps) {
  return <>
      <Hero onNavigate={onNavigate} data-id="element-258" />
      <Stats data-id="element-259" />
      <WhatIsDigitalKey data-id="element-260" />
      <FeatureGrid data-id="element-261" />
      <ControlModes data-id="element-262" />
      <Security data-id="element-263" />
      <UseCases onNavigate={onNavigate} data-id="element-264" />
      <Installation data-id="element-265" />
      <VehicleModels data-id="element-266" />
      <FAQ data-id="element-267" />
      <FinalCTA onNavigate={onNavigate} data-id="element-268" />
    </>;
}